exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabslang{display:flex;cursor:pointer}.tablang{padding:5px}.tablang.active{background:#ae69f5;color:#fff}", ""]);

// exports
